var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 65,
    viewBox: "0 0 321 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.761719 0.652344H309.727C309.727 0.652344 320.762 20.1556 320.762 32.6523C320.762 45.1491 309.727 64.6523 309.727 64.6523H0.761719C0.761719 64.6523 11.7799 45.1491 11.7799 32.6523C11.7799 20.1556 0.761719 0.652344 0.761719 0.652344Z",
    fill: "url(#paint0_linear_310_281)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_310_281",
    x1: 0.761719,
    y1: 32.6523,
    x2: 320.762,
    y2: 32.6523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B30505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9819C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape1);
export default __webpack_public_path__ + "static/media/shape1.5feea830c49f52ea489a00992cbf1fae.svg";
export { ForwardRef as ReactComponent };